import {
    Routes,
    Route,
} from "react-router-dom";

import TransactionViewPage from "./transaction-detailed-view.component";
import TransactionsPage from "./transactions-page.component";


export default function TransactionRoutes() {
    return (
        <Routes>
            <Route path="/" element={<TransactionsPage />} />
            <Route path="view/:id" element={<TransactionViewPage load />} />

        </Routes>
    )
}